const reactQueryBuilder = require('react-querybuilder');
const { calculateMainDateRange, calculateCompareDateRanges } = require('../constants/date');
const { dayjs } = require('./date');

function isQueryEmpty(query) {
  return !query?.rules?.length;
}

function combineQueries(...queries) {
  const query = queries.filter(q => !isQueryEmpty(q)).reduce((acc, q) => ({
    ...acc,
    rules: [...acc.rules, ...(q.combinator === 'and' ? q.rules : [q])],
  }), { combinator: 'and', rules: [] });
  return query;
}

function getDateQuery({ dateRangeConfig, globalDateRangeConfig }) {
  if (!dateRangeConfig) return null;

  let dateRange = calculateMainDateRange(dayjs, dateRangeConfig.compareToPrevious ? globalDateRangeConfig : dateRangeConfig);

  if (dateRangeConfig.compareToPrevious) {
    [dateRange] = calculateCompareDateRanges(dayjs, dateRange, { ...globalDateRangeConfig, compareToPrevious: true, comparePeriod: dateRangeConfig.comparePeriod });
  }

  return {
    combinator: 'and',
    rules: [{
      field: 'date',
      value: [dateRange.startDate, dateRange.endDate],
      operator: 'between',
    }],
  };
}

function getBaseQuery({ customerId, dataSourceIds }) {
  const baseQuery = {
    combinator: 'and',
    rules: [{
      field: 'customerId',
      value: customerId,
      operator: '=',
    }],
  };

  if (dataSourceIds?.length > 0) {
    baseQuery.rules.push({
      field: 'dataSourceId',
      value: dataSourceIds,
      operator: 'in',
    });
  }

  return baseQuery;
}

module.exports = {
  reactQueryBuilder,
  isQueryEmpty,
  combineQueries,
  getDateQuery,
  getBaseQuery,
};
